<template>
  <v-dialog width="600px" :value="value" persistent scrollable>
    <v-card class="kbLight">
      <v-toolbar class="kbLightBlue" dark flat text>
        <v-toolbar-title>
          {{ $t('general.setAdministratorCallConfig') }}
        </v-toolbar-title>

        <v-spacer />

        <v-btn icon @click="toggleModal()">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text v-if="loadingAdministratorCallConfig">
        <LoadingComponent :circleSize="80"
                          :message="$t('general.loadingAdministratorCallConfig')"
                          height="350px" />
      </v-card-text>

      <v-card-text v-else>
        <v-container class="pa-0" fluid>
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col cols="12" class="pb-0">
                <span class="kbDarkBlueText--text d-block text-h6 mb-1 font-weight-regular">
                  {{ $t('general.enterClientId') }}
                </span>
                <v-text-field background-color="kbWhite"
                              color="kbDarkBlueText"
                              :label="$t('general.clientId')"
                              :rules="[rules.required]"
                              solo
                              v-model="callConfig.clientId"/>
              </v-col>

              <v-col cols="12" class="pb-0">
                <span class="kbDarkBlueText--text d-block text-h6 mb-1 font-weight-regular">
                  {{ $t('general.enterClientEmail') }}
                </span>
                <v-text-field background-color="kbWhite"
                              color="kbDarkBlueText"
                              :label="$t('general.email')"
                              :rules="[rules.required, rules.email]"
                              solo
                              v-model="callConfig.userEmail"/>
              </v-col>

              <v-col cols="12" class="pb-0">
                <span class="kbDarkBlueText--text text-h6 d-block mb-1 font-weight-regular">
                  {{ $t('general.enterClientPassword') }}
                </span>
                <v-checkbox v-model="showPasswordInput"
                            class="mb-2"
                            :label="$t('general.updatePassword')"
                            v-if="administratorCallConfig.clientId" />

                <v-text-field background-color="kbWhite"
                              color="kbDarkBlueText"
                              :label="$t('general.password')"
                              :rules="[rules.required]"
                              solo
                              type="password"
                              v-if="!administratorCallConfig.clientId || showPasswordInput"
                              v-model="callConfig.password" />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>

        <v-btn class="mr-2"
               @click="toggleModal()"
               color="red"
               outlined>
          {{ $t('general.cancel') }}
        </v-btn>

        <v-btn color="mainButtons"
               dark
               @click="updateAdministratorCallConfig()"
               :loading="submitLoading">
          {{ $t('general.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import notifications from '@/libs/notifications'
import rules from '@/libs/rules'
import LoadingComponent from '@/components/ui/LoadingComponent'

export default {
  components: {
    LoadingComponent
  },
  computed: {
    ...mapGetters(['administratorCallConfig'])
  },
  data () {
    return {
      callConfig: {
        clientId: '',
        userEmail: '',
        password: ''
      },
      showPasswordInput: false,
      submitLoading: false,
      loadingAdministratorCallConfig: false,
      rules
    }
  },
  methods: {
    clearCallConfigForm () {
      if (this.$refs.form) {
        this.$refs.form.reset()
      }
    },
    async getAdministratorCallConfig () {
      try {
        this.loadingAdministratorCallConfig = true
        await this.$store.dispatch('getAdministratorCallConfig', {
          companyId: this.$store.getters.companyUuid,
          administratorId: this.selectedAdministratorId
        })
        this.setLocalAdministratorCallConfig()
        this.loadingAdministratorCallConfig = false
      } catch (e) {
        this.loadingAdministratorCallConfig = false
        notifications.error(e)
      }
    },
    setLocalAdministratorCallConfig () {
      this.callConfig = { ...this.administratorCallConfig }
    },
    async updateAdministratorCallConfig () {
      if (!this.$refs.form.validate()) return
      this.submitLoading = true
      try {
        const data = {
          clientId: this.callConfig.clientId,
          password: this.callConfig.password,
          userEmail: this.callConfig.userEmail
        }
        await this.$store.dispatch('updateAdministratorCallConfig', {
          companyId: this.$store.getters.companyUuid,
          administratorId: this.selectedAdministratorId,
          data
        })
        notifications.success(this.$t('general.administratorCallConfigSuccessfullyUpdated'))
        this.submitLoading = false
        this.toggleModal()
      } catch (e) {
        this.submitLoading = false
        notifications.error(e)
      }
    },
    toggleModal () {
      this.clearCallConfigForm()
      this.$emit('input', false)
    }
  },
  props: {
    selectedAdministratorId: {
      type: String,
      default: ''
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value (value) {
      if (value && this.selectedAdministratorId) {
        this.getAdministratorCallConfig()
      }
    }
  }
}
</script>
